var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ai-answer-button-wrapper"
  }, [_c("div", {
    staticClass: "button-item",
    on: {
      click: _vm.shareHandler
    }
  }, [_c("svg-icon", {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      name: "van-icon-share-o"
    }
  }), _c("div", {
    staticClass: "text"
  }, [_vm._v("分享")])], 1), _c("div", {
    staticClass: "button-item",
    style: {
      color: _vm.answer.evaluate === 10 ? "#3B72FF" : "#000"
    },
    on: {
      click: function click($event) {
        return _vm.evaluateHandler(_vm.answer, 10);
      }
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "good-job"
    }
  }), _c("div", {
    staticClass: "text"
  }, [_vm._v("点赞")])], 1), _c("div", {
    staticClass: "button-item",
    style: {
      color: _vm.answer.evaluate === 1 ? "#3B72FF" : "#000"
    },
    on: {
      click: function click($event) {
        return _vm.collectInfo(_vm.answer, 1);
      }
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "bad-job"
    }
  }), _c("div", {
    staticClass: "text"
  }, [_vm._v("点踩")])], 1), _c("div", {
    staticClass: "button-item",
    on: {
      click: _vm.reloadHandler
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "van-icon-replay"
    }
  }), _c("div", {
    staticClass: "text"
  }, [_vm._v("重新生成")])], 1), _vm.isPc ? _c("div", {
    staticClass: "button-item",
    on: {
      click: _vm.exportAnswer
    }
  }, [_c("svg-icon", {
    staticClass: "m-r-4",
    attrs: {
      name: "export"
    }
  }), _c("span", {
    staticClass: "text"
  }, [_vm._v("导出")])], 1) : _vm._e(), _c("collect-bad-info", {
    ref: "collectRef",
    on: {
      submit: _vm.feedback
    }
  }), _c("mini-program-generate-share", {
    ref: "miniProgramShareRef",
    attrs: {
      answer: _vm.answer,
      question: _vm.question
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };